import { ErrorApi, Kvp, Preloader } from 'src/components'
import { getEnvString } from 'src/utils'
import { useServerVersion } from '../../queries'

const InfoVersions = () => {
  const { data, error, refetch, status } = useServerVersion()

  if (status === 'loading' || status === 'idle') {
    return <Preloader />
  }

  if (status === 'error') {
    return <ErrorApi message={error} onClick={refetch} />
  }

  return (
    <div className="grid grid-cols-2 gap-6">
      <Kvp label="server version" title="server version" value={data} />

      <Kvp
        label="client version"
        title="client version"
        value={getEnvString('REACT_APP_VERSION')}
      />
    </div>
  )
}

export default InfoVersions
